import {defineStore} from "pinia";
import {ref} from "vue";
import {useFetch} from "@vueuse/core";
import {BASE_URI} from "@/assets/const";
// import VueCookies from 'vue-cookies'



export const educationsStore = defineStore('educationsStore', () => {

    const isPending = ref(false)
    const direction = ref()

    const getDirectionById = async (directionId) => {
        isPending.value = true;
        // const token = VueCookies.get('token');
        const { error, data } = await useFetch(BASE_URI + "/api/view/directions/"+directionId, {
            method: 'GET',
            // headers: {
            //     'Authorization': `Bearer ${token}`,
            // },
        }).get().json();
            
        if (error.value) {
            console.log(error.value)
            isPending.value = false;
            return error.value;
        } else {
            direction.value = data.value;
            console.log(direction.value)
            isPending.value = false;
        }
    
    }

    return{
        isPending,
        getDirectionById,
        direction
    }

})